module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1008-e4be6aa112a55e40c92289ff73c29121.png";